import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { getSocket } from './socket';

/**
 * Rafraîchit les écrans quand un événement métier du tenant est publié (mission démarrée par le
 * chauffeur, livraison, plein, alerte…) : ws-realtime relaie un signal `update`, on recharge les
 * requêtes affichées. Regroupé sur 1 s pour absorber les rafales (lot GPS, import CSV…).
 */
export const useLiveUpdates = (): void => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const socket = getSocket();
    let timer: number | null = null;
    const onUpdate = (): void => {
      if (timer !== null) return;
      timer = window.setTimeout(() => {
        timer = null;
        void queryClient.invalidateQueries({ refetchType: 'active' });
      }, 1_000);
    };
    socket.on('update', onUpdate);
    return () => {
      socket.off('update', onUpdate);
      if (timer !== null) clearTimeout(timer);
    };
  }, [queryClient]);
};
